import { useQuery, queryOptions } from '@tanstack/react-query';

import { fetchFn, QueryConfig } from '@/lib/react-query';

export const getActivity = (): Promise<{ data: { timestamp: number } }> => {
  return fetchFn('/self-service/auth/activity');
};

export const getActivityQueryOptions = () => {
  return queryOptions({
    queryKey: ['activity'],
    queryFn: () => getActivity(),
  });
};

type UseActivityOptions = {
  queryConfig?: QueryConfig<typeof getActivityQueryOptions>;
};

export const useGetActivity = ({ queryConfig }: UseActivityOptions) => {
  return useQuery({
    ...getActivityQueryOptions(),
    ...queryConfig,
  });
};
